import { isHomeCalendarResponseCurrent } from '@liquid-spirit/api/domains/auth';
import {
  STORAGE_KEYS, persistAuthToken, removeStorageItem, writeStorageItem, writeStorageJSON,
} from '../../utils/storage';
import {
  clearOfflineSnapshots, getActiveQueryOwner, ownsQueryScope, readOfflineSnapshot,
  removeOfflineSnapshot, writeOfflineSnapshot,
} from '../../queries/queryOwnership';

const BOOTSTRAP_SNAPSHOT_FRESHNESS_MS = 90_000;
const META_FAMILY = 'homeBootstrapMeta';

export const clearBootstrapSnapshots = (scope) => {
  if (scope) {
    if (ownsQueryScope(scope)) removeOfflineSnapshot(META_FAMILY, scope);
    return;
  }
  clearOfflineSnapshots();
};

export const readBootstrapSnapshotMeta = (scope = getActiveQueryOwner()) => (
  readOfflineSnapshot(META_FAMILY, scope, null)
);

export const hasFreshBootstrapSnapshot = ({ userId, communityId, scope = getActiveQueryOwner(), now = Date.now(), calendarScope } = {}) => {
  if (!ownsQueryScope(scope)) return false;
  const meta = readBootstrapSnapshotMeta(scope);
  if (!meta || typeof meta.fetchedAt !== 'number') return false;
  if (now < meta.fetchedAt || now - meta.fetchedAt > BOOTSTRAP_SNAPSHOT_FRESHNESS_MS) return false;
  if (calendarScope && (meta.calendarKey !== calendarScope.key
    || !isHomeCalendarResponseCurrent({ calendarContext: meta.calendarContext }, calendarScope, now))) return false;
  return String(meta.userId || '') === String(userId || scope.actorId)
    && String(meta.communityId || '') === String(communityId || '');
};

export const seedAuthStorage = ({ token, refreshToken, user }) => {
  persistAuthToken(token || null);
  if (refreshToken) writeStorageItem(STORAGE_KEYS.AUTH_REFRESH_TOKEN, refreshToken);
  if (user) writeStorageJSON(STORAGE_KEYS.AUTH_USER, user, { area: 'session' });
  removeStorageItem(STORAGE_KEYS.LEGACY_REFRESH_TOKEN);
  removeStorageItem(STORAGE_KEYS.LEGACY_USER);
};

export const persistBootstrapSnapshot = ({
  activities = [], previewFeed = [], lsa = [], community, stats,
  recentComments = [], scope, collectionScope = scope, calendarScope, calendarContext,
}) => {
  if (!ownsQueryScope(scope) || !ownsQueryScope(collectionScope)) return;
  for (const [family, value] of Object.entries({ previewFeed, recentComments })) {
    writeOfflineSnapshot(family, collectionScope, value);
  }
  for (const [family, value] of Object.entries({ lsa, communityMeta: community, communityStats: stats })) {
    writeOfflineSnapshot(family, scope, value);
  }
  writeOfflineSnapshot(META_FAMILY, scope, {
    calendarKey: calendarScope?.key, calendarContext,
    fetchedAt: Date.now(), userId: scope.actorId, communityId: collectionScope.communityId,
    activityCount: activities.length, previewFeedCount: previewFeed.length,
    recentCommentsCount: recentComments.length, hasStats: Boolean(stats), lsaCount: lsa.length,
  });
};
